<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<div class="alert alert-warning" role="alert" *ngIf="isFederatedUser">
  <i class="alert-close" aria-hidden="true"></i>
  Editing password and security questions is not available for AD federated users. Please contact your administrator.
</div>

<div class="alert alert-warning" role="alert" *ngIf="isSupport">
  <i class="alert-close" aria-hidden="true"></i>
  Editing password and security questions is not available for Support users.
</div>

<button class="btn btn-default mb-3" staticAlertClosed="false"  type="button" *ngIf="redirectFromOtherApp" (click)="back()">Back</button>

<div *ngIf="!isFederatedUser && !isSupport">
  <re-change-password></re-change-password>
  <re-alert *ngIf="redirectFromOtherApp" [dismissible]="false" type="info">Your security questions have not yet been set up.  Click "Edit" to set them up now or click "Back" to skip and create them later.</re-alert>
  <re-security-questions></re-security-questions>
  <re-two-factor *ngIf="mfaEnabled"></re-two-factor>
</div>
